import { Ref } from 'react'
import { CopyIcon } from '../../GenericComponents/copyIcon'
import { getBaseUrl, getUrlVars, toBinary } from '../../Utils'
import { formNavigation } from './formNavigation'
import { ValidatorMetaMap } from './formInterfaces'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import Cookies from 'js-cookie'
import { setCookie } from '../../GlobalMethods'
import { ObjectContext } from '../../Components/OCV/OCVTypes'

declare let window: any

//Most of the functions in this file are legacy functions migrated from formsLayoutGen2
export const formHelp = {
    COMPLETED: 'Completed',
    INCOMPLETE: 'Incomplete',
    INVALID: 'Invalid',
    REQUIRED: 'Required',
    OPTIONAL: 'Optional',
    ABNORMAL: 'Abnormal',
    SIGNED: '1',
    StatusLabel: function (value: string) {
        let style =
            value !== formHelp.COMPLETED
                ? value !== formHelp.INVALID && value !== formHelp.REQUIRED
                    ? 'warning'
                    : 'error'
                : 'success'
        if (value === formHelp.ABNORMAL) {
            style = 'warning'
        }
        return value !== formHelp.COMPLETED ? <span>{value}</span> : ''
    },
    validityFieldStatus: function (validity: { warning: any; issue: any }) {
        if (validity.warning) return formHelp.StatusLabel(formHelp.ABNORMAL)
        if (validity.issue) return formHelp.StatusLabel(formHelp.INVALID)

        return ''
    },
    unlockForm: (
        formName: string,
        dataObjectId: string,
        isNavigationEnabled: string,
        isCopyPasted: boolean,
        buttonClicked: string,
        drillThruObj: { [s: string]: any },
        setTabGuid: (s: string) => void,
        setDrillThruObj: (s: { [s: string]: any }) => void,
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void,
        setShowPopupMessage: (show: boolean) => void
    ) => {
        // AJAX call to check Edit Security code and locked Form
        // On Success enable edit form
        let xhr = new XMLHttpRequest()
        let endpointUrl = getBaseUrl() + 'API/v3/FORMENGINE/Unlock'
        xhr.open('POST', endpointUrl)
        xhr.setRequestHeader('Content-Type', 'application/json')

        xhr.setRequestHeader('buttonAudit', buttonClicked)
        if (sessionStorage.getItem('formLockGuid') != undefined) {
            xhr.setRequestHeader('formLockGuid', sessionStorage.getItem('formLockGuid') || '')
        }
        xhr.setRequestHeader('formName', formName)
        xhr.setRequestHeader('dataObjectId', dataObjectId)
        xhr.responseType = 'json'
        xhr.setRequestHeader('section', '200') // 200 is fixed for Form Edit check
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                let st = xhr.response
                if (st.statusCode !== 200) {
                    console.error('*ERR* Failed to update API/v3/FORMENGINE/Unlock ')
                } else {
                    //Delete Guid on success of unlock
                    sessionStorage.removeItem('formLockGuid')
                    sessionStorage.removeItem(`_drillThruObj_${dataObjectId}`)
                    if (buttonClicked.toLowerCase() == 'yes' || isNavigationEnabled == 'false') {
                        setTimeout(function () {
                            let ww = window.open(location, '_self')
                            ww.close()
                        }, 10)
                    } else if (isNavigationEnabled == 'true' && !isCopyPasted) {
                        setPopUpInfo(
                            'Form Navigation Alert',
                            'Searching for next available form',
                            false,
                            -1,
                            []
                        )
                        setShowPopupMessage(true)
                        let _drillThruParams = ''

                        if (drillThruObj == undefined) {
                            FoundationsGenericToaster('error', 'Form data missing')
                        } else {
                            _drillThruParams = toBinary(JSON.stringify(drillThruObj))
                            formNavigation.navigateThroughWorklist(
                                {
                                    direction: 'forward',
                                    drillthruObj: _drillThruParams,
                                    columnsData: drillThruObj.columnsData,
                                },
                                formName,
                                dataObjectId,
                                setTabGuid,
                                setDrillThruObj,
                                setPopUpInfo,
                                setShowPopupMessage
                            )
                        }
                    }
                }
            }
        }

        xhr.send()
    },
    fromBinary: (encoded: string) => {
        const binary = atob(encoded)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = binary.charCodeAt(i)
        }
        return String.fromCharCode(...new Uint16Array(bytes.buffer))
    },
    checkandremove_Issingletoncookies: (formName: string, dataObjectId: string) => {
        //FP-5973 adding js function to check and remove cookies for SingletonForms
        let tempInfo =
            Cookies.get('SingletonFormsInfo') !== undefined
                ? JSON.parse(Cookies.get('SingletonFormsInfo') || '{}')
                : {}
        if (tempInfo != undefined) {
            let formNames = tempInfo
            if (
                formName.toLowerCase() in formNames &&
                formNames[formName.toLowerCase()].dataObjectId == dataObjectId
            ) {
                if (formNames[formName.toLowerCase()].Count > 1) {
                    formNames[formName.toLowerCase()].Count--
                } else {
                    delete formNames[formName.toLowerCase()]
                }
                setCookie('SingletonFormsInfo', JSON.stringify(formNames), 0)
            }
        }
    },
    checkandset_Issingletoncookies: (baseURLForLauncher: string | null) => {
        //FP-5973 adding js function to check and set cookies for SingletonForms
        //do this processing only if its formsengine URL
        if (
            baseURLForLauncher != null &&
            baseURLForLauncher != '' &&
            baseURLForLauncher.includes('FormsEngine')
        ) {
            let formName = ''
            let dataObjectId = ''
            let params = baseURLForLauncher.split('?')[1].split('&')
            for (let i = 0; i < params.length; i++) {
                let tempParam = params[i].split('=')
                if (tempParam[0].toLowerCase() == 'formname') {
                    formName = tempParam[1].toLowerCase()
                }
                if (tempParam[0].toLowerCase() == 'dataobjectid') {
                    dataObjectId = tempParam[1]
                }
            }
            if (formName != undefined && formName != '') {
                let object = { dataObjectId: dataObjectId, Count: 1 }
                let tempInfo =
                    Cookies.get('SingletonFormsInfo') !== undefined
                        ? JSON.parse(Cookies.get('SingletonFormsInfo') || '{}')
                        : {}
                if (!(formName.toLowerCase() in tempInfo)) {
                    tempInfo[formName.toLowerCase()] = object
                    setCookie('SingletonFormsInfo', JSON.stringify(tempInfo), 0)
                } else if (
                    formName.toLowerCase() in tempInfo &&
                    tempInfo[formName.toLowerCase()].dataObjectId == dataObjectId &&
                    tempInfo[formName.toLowerCase()].Count > 0
                ) {
                    tempInfo[formName.toLowerCase()].Count++
                    setCookie('SingletonFormsInfo', JSON.stringify(tempInfo), 0)
                }
            }
        }
    },
    isSmartForm: (schema: { sections: any[] }, metadata: { [x: string]: any }) => {
        if (schema === undefined) return 'Sorry, there was an issue processing the form schema.'
        const errors: string[] = []
        schema?.sections.forEach(function (section, index) {
            const fields = []
            if (section.instances && section.instances[0]) {
                if (
                    section.instances[0].fields &&
                    typeof section.instances[0].fields === 'string'
                ) {
                    const metaIds = section.instances[0].fields.replace(/\s*\,\s*/g, ',').split(',')

                    for (let i = 0; i < metaIds.length; i++) {
                        const metaId = metaIds[i]
                        let found = null
                        for (let item in metadata) {
                            if (metadata.hasOwnProperty(item)) {
                                if (metaId === metadata[item].id) {
                                    found = metadata[item]
                                    break
                                }
                            }
                        }
                        if (found != null) {
                            fields.push(formHelp.clone(found, true))
                        } else {
                            errors.push(
                                `Invalid section ${index + 1} (${section.name}): missing metadata (ID ${metaId})`
                            )
                        }
                    }
                    // TODO !! Change field validation handling
                    // fields.forEach(function(target) {
                    //     const fieldId = target.id;
                    //     const validationType = (target.validator != null) ? target.validator.toLowerCase() : target.validator;
                    //     if (target.type === "text") {
                    //         target.validator = "text";
                    //     }
                    //     if (target.validator) {

                    //         if (Validation.hasOwnProperty(target.validator)) {
                    //             target.validator = function(field: { value: string; id: any }) {
                    //                 if (!isEmptyField(field)) {

                    //                     if (target.type === "text" && validationType == "datetime") {
                    //                         field.value = (field.value.split(" ").length > 1 && field.value.split(" ")[1] == "00:00") ? field.value.split(" ")[0] : field.value;
                    //                     }

                    //                     let v2 = validate2(field.id, field.value);
                    //                     let h2;
                    //                     if (v2.error) {
                    //                         h2 = "Please correct the following issue: ";
                    //                         return { issue: h2, hint: v2.help, warning: v2.warning };
                    //                     } else if (v2.warning) {
                    //                         h2 = "Please check: ";
                    //                         return { issue: h2, hint: v2.help, warning: v2.warning };
                    //                     }
                    //                 }
                    //                 return null;
                    //             };
                    //         } else {
                    //             let emsg = "Invalid section {0} ({1}): unknown validator '{2}' (ID {3})"
                    //                 .at(index + 1, section.name, target.validator, fieldId);
                    //             console.log(emsg);
                    //             errors.push(emsg);
                    //         }
                    //     }
                    // });
                }
                section.instances[0].fields = fields
            }
            // TODO fix handling below
            // else {
            //     let msg = "Invalid section {0} ({1}): missing instance[0]".at(index + 1, section.name);
            //     console.log(msg);
            //     errors.push(msg);
            // }
            if (section.segmentInstances && section.segmentInstances[0]) {
                let segmentFields = []
                if (
                    section.segmentInstances[0].fields &&
                    typeof section.segmentInstances[0].fields === 'string'
                ) {
                    let metaIds = section.segmentInstances[0].fields
                        .replace(/\s*\,\s*/g, ',')
                        .split(',')

                    for (let i = 0; i < metaIds.length; i++) {
                        let metaId = metaIds[i]
                        let found = null
                        for (let item in metadata) {
                            if (metadata.hasOwnProperty(item)) {
                                if (metaId === metadata[item].id) {
                                    found = metadata[item]
                                    break
                                }
                            }
                        }
                        if (found != null) {
                            segmentFields.push(formHelp.clone(found, true))
                        } else {
                            // TODO change error handling
                            // errors.push("Invalid section {0} ({1}): missing metadata (ID {2})"
                            //     .at(index + 1, section.name, metaId));
                        }
                    }
                    segmentFields.forEach(function (target) {
                        let fieldId = target.id
                        if (target.type === 'text') {
                            target.validator = 'text'
                        }
                        // TODO !! change validation  handling
                        // if (target.validator) {
                        //     if (Validation.hasOwnProperty(target.validator)) {
                        //         target.validator = function (field: { id: any; value: { match: (arg0: any) => null } }) {
                        //             if (!isEmptyField(field)) {

                        //                 let v2 = validate2(field.id, field.value);
                        //                 let h2;
                        //                 if (v2.error) {
                        //                     h2 = "Please correct the following issue: ";
                        //                     return { issue: h2, hint: v2.help, warning: v2.warning };
                        //                 } else if (v2.warning) {
                        //                     h2 = "Please check: ";
                        //                     return { issue: h2, hint: v2.help, warning: v2.warning };
                        //                 }
                        //             }
                        //             return null;
                        //         };
                        //     } else {
                        //         let emsg = "Invalid section {0} ({1}): unknown validator '{2}' (ID {3})"
                        //             .at(index + 1, section.name, target.validator, fieldId);
                        //         console.log(emsg);
                        //         errors.push(emsg);
                        //     }
                        // }
                    })
                }
                section.segmentInstances[0].fields = segmentFields
            }
        })
        return !errors.length
            ? ''
            : ['Sorry, this is not a Smart Form.'].concat(errors).join('\r\n')
    },
    deserialize: (
        metaTemplate: { instances: any[]; sectionGroups: string | undefined },
        loadedFields: any[][]
    ) => {
        let metaTemplateInst = metaTemplate.instances[0]
        let instances: any[] = []
        let theFields = loadedFields
        let sectionObj = {
            id: '',
            name: '',
            type: 'sectionChild',
            value: null,
            required: true,

            empty: [null, -1],
            domain: [
                { key: 'No', value: 'No' },
                { key: 'Yes', value: 'Yes' },
            ],
            validator: null,
            help: '',
        }
        if (metaTemplate.sectionGroups != undefined) {
            let sectionGroups = JSON.parse(metaTemplate.sectionGroups)[0]

            //  Add CheckboxGroup fields as checkbox instances to set their values.
            let sectionGroupsFields = ''
            for (let i = 0; i < sectionGroups.fields.length; i++) {
                sectionGroupsFields += sectionGroups.fields[i].values.replace(/\s/g, '') // Replace tab or white spaces when we add fields in new line
                sectionGroupsFields += ','
            }
            let sectionGroupIds = sectionGroupsFields.split(',')
            sectionGroupIds.forEach(function (idx) {
                let tempObj = formHelp.clone(sectionObj, true)
                tempObj.id = idx
                metaTemplateInst.fields.push(tempObj)
            })
            let checkedSections: any[] = []
            sectionGroups.fields.forEach(function (x: { key: any }) {
                loadedFields[0].forEach(function (y: { FieldId: any; FieldValue: any[] }) {
                    if (x.key == y.FieldId) {
                        metaTemplateInst.fields.forEach(function (z: {
                            id: any
                            multiSelectSections: string
                        }) {
                            if (x.key == z.id && z.multiSelectSections) {
                                JSON.parse(z.multiSelectSections).forEach(function (m: {
                                    value: any
                                    key: any
                                }) {
                                    if (y.FieldValue && y.FieldValue.length) {
                                        y.FieldValue.forEach(function (f: any) {
                                            if (f == m.value) {
                                                checkedSections.push(m.key)
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            })
            checkedSections.forEach(function (s) {
                metaTemplateInst.fields.forEach(function (m: { id: any; value: number }) {
                    if (s == m.id) {
                        m.value = 1
                    }
                })
            })
        }

        ////////////////////

        if (theFields.length === 0) {
            instances[0].fields = metaTemplateInst.fields
            instances.push(metaTemplateInst)
            return { newInstances: instances, metaTemplateInst: metaTemplateInst }
        }

        try {
            theFields.map((formInstance) => {
                let lesionKey = -1
                let template = formHelp.clone(metaTemplateInst, true),
                    fields: any[] = []
                let dict = {}
                formInstance.map(function (formField, fieldIdx) {
                    const fieldId = formField.FieldId?.toString()
                    try {
                        // TODO fieldId shold not be p[assed though window

                        let value = ''
                        let name = ''
                        let position = ''
                        if (formField.FieldValue && formField.FieldValue.length > 0) {
                            value =
                                typeof formField.FieldValue[0] === 'boolean'
                                    ? formField.FieldValue[0]
                                        ? 1
                                        : 0
                                    : formField.FieldValue[0] !== null
                                      ? formField.FieldValue[0].toString()
                                      : ''
                        }

                        if (formHelp.hasFieldIndex(formField)) {
                            value = ''
                        }

                        if (formField.FieldName && formField.FieldName[0] === 'Lesion Key') {
                            lesionKey = Number(formField.FieldValue[0])
                        }

                        let found = null

                        // TODO make sure that metaTemplateInst.fields matches what we see on 25.1
                        for (const item in metaTemplateInst.fields) {
                            if (metaTemplateInst.fields.hasOwnProperty(item)) {
                                if (fieldId === metaTemplateInst.fields[item].id) {
                                    found = JSON.parse(
                                        JSON.stringify(metaTemplateInst.fields[item])
                                    )
                                    found.domain = JSON.parse(found.domain)
                                    break
                                }
                            }
                        }

                        let field = found != null ? JSON.parse(JSON.stringify(found)) : null

                        if (field) {
                            if (name !== '') field.name = name
                            field.position = position
                            field.value =
                                typeof value === 'string' && field.domain && field.domain.length
                                    ? field.domain.reduce(function (
                                          sofar: null,
                                          pair: { key: string },
                                          i: any
                                      ) {
                                          return sofar === null
                                              ? value.toLowerCase() === pair.key.toLowerCase()
                                                  ? i
                                                  : null
                                              : sofar
                                      }, null)
                                    : value

                            //if (field.value != null && field.value.length > 0) {
                            //    if (field.value
                            //        .indexOf(":") >
                            //        -1 &&
                            //        field.value.match(/^\d\d\d\d-\d\d-\d\d.*/)) {
                            //        let dt = MedUnits.toDate(field.value);
                            //        field.value = MedUnits.toFormDate(dt, true);
                            //    }
                            //}
                            if (formHelp.isEmptyField(field)) {
                                field.value = null
                            }
                            field.fieldIndex = formField.FieldIndex || []
                            field.fieldValue = formField.FieldValue || []
                            field.FileUrl = formField.FileUrl || ''
                            field.FileName = formField.FileName || ''
                            field.FromFile = formField.FromFile || ''
                            fields.forEach((f3: any) => {
                                if (f3 === field.id) {
                                    let msg3 =
                                        '*ERR* Serious error. Server sent duplicate field id ' +
                                        field.id
                                    alert(msg3)
                                }
                            })
                            field.owner = formInstance

                            fields.push(field)
                        }
                    } catch (ex2) {
                        console.error(
                            '*ERR* Deserialization Parsing failure at formField ' +
                                formField +
                                ' ' +
                                ex2
                        )
                    }
                })

                template.fields = fields
                if (lesionKey >= 0) template.lesionKey = lesionKey
                instances.push(template)
            })
        } catch (ex) {
            console.error('*ERR* De-serialization failure' + ex)
        }

        return { newInstances: instances, metaTemplateInst: metaTemplateInst }
    },
    difference: (a: any[], b: any[]) => {
        return a.filter((x) => !b.includes(x))
    },
    addMissingField: (
        sectionTemplateFields: { fields: any[] },
        fieldset: any[],
        onceOnly: any[]
    ) => {
        if (!fieldset || !sectionTemplateFields) return
        onceOnly = onceOnly || []
        let shouldHaveIds = sectionTemplateFields.fields.map(function (s: { id: any }) {
            return s.id
        })
        let idx = 0
        fieldset.forEach(function (fs: { fields: any[] }) {
            let foundIds = fs.fields.map(function (fl) {
                return fl.id
            })
            let missingFieldIds = formHelp.difference(shouldHaveIds, foundIds)

            if (missingFieldIds && missingFieldIds.length > 0) {
                //  console.log("Fieldset " + idx + " is missing " + missingFieldIds + " from instance " + idx);
                missingFieldIds.forEach(function (missingFieldId: any) {
                    let templateField = sectionTemplateFields.fields.find(function (stf: {
                        id: any
                    }) {
                        return missingFieldId === stf.id
                    })

                    if (templateField) {
                        let templateClone
                        let okToAdd = true
                        let sOnly = ''

                        if (onceOnly.length > 0) {
                            let once = onceOnly.find(function (o: any) {
                                return o === templateField.id
                            })
                            sOnly = once ? ' *only*' : ''
                            if (once && idx > 0) okToAdd = false
                        }

                        if (okToAdd) {
                            templateClone = formHelp.clone(templateField, false)
                            fs.fields.push(templateClone)
                        }
                    }
                })
            }
            idx++
        })
    },
    clone: (obj: any, deep: any) => {
        if (obj !== null && typeof obj !== 'undefined') {
            if (Object.prototype.toString.call(obj) !== '[object Array]') {
                if (
                    typeof obj !== 'boolean' &&
                    typeof obj !== 'number' &&
                    typeof obj !== 'string' &&
                    typeof obj !== 'function'
                ) {
                    let result: { [s: string]: any } = {}
                    for (let member in obj) {
                        if (Object.prototype.hasOwnProperty.call(obj, member)) {
                            let val: any = obj[member]
                            result[member] = deep ? formHelp.clone(val, deep) : val
                        }
                    }
                    return result
                } else {
                    return obj
                }
            } else {
                return obj.map(function (item: any) {
                    return formHelp.clone(item, deep)
                })
            }
        } else {
            return obj
        }
    },
    hasFieldIndex: (field: { [s: string]: any }) => {
        return field.fieldIndex && field.fieldIndex.length > 0
    },
    isEmptyField: (field: { [s: string]: any }) => {
        if (field.empty === undefined) field.empty = []
        return (
            field.empty.filter(function (value: any) {
                return field.value === value
            }).length > 0
        )
    },
    getFormsPopupMessageCounter: (counter: number) => {
        return counter > 0
            ? '<h3 id="session-popup-forms"> This form times out in ' +
                  counter.toString() +
                  ' seconds. Move cursor to extend the time.</h3>'
            : '<h3 id="session-popup-forms"> Your form has timed out.</h3>'
    },
    isValidSection: (section: {
        sectionGroups: undefined
        name: string | string[]
        instances: any
    }) => {
        if (section?.sectionGroups != undefined)
            // Skip it for sectionGroups section for now
            return true

        // TODO is any of the below code used anywhere? It appears no (deviceCompoCtrl is undefined everywhere)
        // let res = SectionType(section) && array(isValidFieldSet)(section.instances, addAuditComment);
        // note: addAuditComment takes a string an addis to the commentsAudit ref in formsengine
        //res = res || showSection(section.name, App.form.sections).hide;

        // if (App.deviceCompoCtrl && res && (section.name.indexOf("J") >= 0)) {
        //     let devStat = App.deviceCompoCtrl.isValid();
        //     // console.log("*INFO* Device section status " + devStat);
        //     res = devStat;
        // }

        // if (res) reqFieldStatus("All required fields in this section are complete.");
        // return res;
        return false
    },

    // TODO !! handle this data with lastorw, firstcol etc
    // updatelastupdatedbydate: function () {
    //     //changes the timestamp to be more readable and customizable to user's country using tolocaledatstring. Date can be reduced by deleting the options.
    //     let date = new Date(Date.parse(lastrow));
    //     let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    //     let when = date.toLocaleDateString("en-US", options);
    //     $("#whentag").html = when.search("Invalid") > -1 ? "" : when;
    //     $("#lastupdatedbytag").html = firstCol;
    // },
    getOCVFormattedView: (
        field: any[],
        id: string,
        setDialogObject?: (arg0: ObjectContext) => void,
        setDialogVisible?: (arg0: boolean) => void
    ) => {
        const columnKeys = field.length > 0 ? Object.keys(field[0]) : field
        const tableValues = field

        return (
            <>
                <table
                    className="admin-table"
                    style={{ display: 'table', tableLayout: 'fixed' }}
                    id={id}
                >
                    {columnKeys && columnKeys.length > 0 && (
                        <thead>
                            <tr className="admin-row-header">
                                {columnKeys.map((column: string, index: number) => {
                                    if (column.toLowerCase() == 'errormessage')
                                        return (
                                            <th
                                                key={index}
                                                className="left"
                                                data-sorter="false"
                                                style={{
                                                    background: '#ff0000b3',
                                                    fontWeight: '600',
                                                }}
                                            >
                                                Error fetching section data - Please Contact Admin
                                            </th>
                                        )
                                    else
                                        return (
                                            <th key={index} className="left" data-sorter="false">
                                                {column}
                                            </th>
                                        )
                                })}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {tableValues.length == 0 ? (
                            <tr className="ocv-table-row" style={{ textAlign: 'center' }}>
                                <td className="left" colSpan={columnKeys.length}>
                                    No data available to display
                                </td>
                            </tr>
                        ) : (
                            <></>
                        )}
                        {tableValues.map(function (
                            value: { [x: string]: any },
                            valueIndex: number
                        ) {
                            let tableRow = value
                            // let firstCol = tableRow.length > 0 ? tableRow[0] : "";
                            return (
                                <tr key={valueIndex} className="ocv-table-row">
                                    {columnKeys.map(function (columnName: string, c_index: number) {
                                        return (
                                            <td key={c_index} className="left" data-sorter="false">
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            typeof tableRow[columnName] ===
                                                                'string' &&
                                                            tableRow[columnName]
                                                                ?.replace('onclick', 'oldOnClick')
                                                                .replace(
                                                                    '<span ',
                                                                    "<span class='darken'"
                                                                ),
                                                    }}
                                                    onClick={
                                                        setDialogObject !== undefined &&
                                                        setDialogVisible !== undefined &&
                                                        typeof tableRow[columnName] === 'string' &&
                                                        tableRow[columnName].includes(
                                                            'openObjectViewDialog'
                                                        )
                                                            ? () => {
                                                                  const index1 =
                                                                      tableRow[columnName].indexOf(
                                                                          '{'
                                                                      )
                                                                  const index2 =
                                                                      tableRow[columnName].indexOf(
                                                                          '}'
                                                                      )
                                                                  const configString =
                                                                      index1 > 0 && index2 > 0
                                                                          ? tableRow[columnName]
                                                                                .substring(
                                                                                    index1,
                                                                                    index2 + 1
                                                                                )
                                                                                ?.replaceAll(
                                                                                    '&quot;',
                                                                                    "'"
                                                                                )
                                                                                .replaceAll(
                                                                                    "'",
                                                                                    '"'
                                                                                )
                                                                          : '{}'
                                                                  const configObject =
                                                                      JSON.parse(configString)
                                                                  configObject.mdsColumnID =
                                                                      parseInt(
                                                                          configObject.mdsColumnID ??
                                                                              -1
                                                                      )
                                                                  setDialogObject(configObject)
                                                                  setDialogVisible(true)
                                                              }
                                                            : () => {}
                                                    }
                                                ></span>{' '}
                                                {formHelp.stripHtml(tableRow[columnName]) ? (
                                                    <CopyIcon
                                                        id={'' + columnName + '_' + c_index}
                                                        copyText={formHelp.stripHtml(
                                                            tableRow[columnName]
                                                        )}
                                                    />
                                                ) : (
                                                    <></>
                                                )}
                                            </td>
                                        )
                                        // let lastrow = tableRow;
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {/* TODO !! handle error case */}
                {/*             return m("h2", "Sorry, unable to process the request. Please contact HealthLevel support. Thank you."); */}
            </>
        )
    },
    arraysEqual: function (a: any[], b: any[]) {
        if (a === b) return true
        if (a == null || b == null) return false
        if (a.length !== b.length) return false

        // If you don't care about the order of the elements inside
        // the array, you should sort both arrays here.
        // Please note that calling sort on an array will modify that array.
        // you might want to clone your array first.

        for (let i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false
        }
        return true
    },
    isDependencyOk: function (
        loaded: boolean,
        field: { [s: string]: any },
        setIndex: number,
        schemaSections: any[],
        validatorMetaMap: ValidatorMetaMap,
        templateType: string,
        fieldset: { fields?: any; lesionKey?: any },
        tab: any,
        addAuditComment: (s: string) => void,
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void,
        setShowPopupMessage: (show: boolean) => void
    ) {
        let res = formHelp.isDependencyOk2(
            loaded,
            field,
            setIndex,
            schemaSections,
            validatorMetaMap,
            templateType,
            fieldset,
            tab,
            addAuditComment,
            setPopUpInfo,
            setShowPopupMessage
        )
        // console.log("Dependency:" + field.id + "." + setIndex + ":" + res);
        return res
    },
    isDependencyOk2: function (
        loaded: boolean,
        field: { [s: string]: any },
        setIndex: number,
        schemaSections: any[],
        validatorMetaMap: ValidatorMetaMap,
        templateType: string,
        fieldset: { fields?: any; lesionKey?: any },
        tab: any,
        addAuditComment: (s: string) => void,
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void,
        setShowPopupMessage: (show: boolean) => void
    ) {
        fieldset = fieldset || {}
        tab = tab || ''
        if (!field) {
            return true
        }

        if (tab.length > 24) {
            throw 'Possible infinite recurive call involving field ' + field.id
        }

        field.disp = true
        const v = formHelp.enableCondition(field.id, validatorMetaMap, templateType)
        let parentValue = ''
        if (!v) return true

        const getParentField = function (sections2: any[], parentId: string) {
            let nParentId = Number(parentId)
            if (nParentId >= 8000 && nParentId < 8029) {
                // Section H, contains multiple instances;
                // first find if there is one in current fieldset
                let inSetFound = sections2[10].instances[setIndex].fields.find(function (item: {
                    id: any
                }) {
                    return item.id === parentId
                })
                if (inSetFound) {
                    return inSetFound
                }
            }

            let pf = null
            sections2.forEach(function (es, secIdx) {
                es.instances.forEach(function (ei: { fields: any[] }) {
                    ei.fields.forEach(function (ef) {
                        if (ef.id == parentId) {
                            pf = ef
                            return
                        }
                    })
                })
            })
            return pf
        }
        const metaFormName = getUrlVars()['formName']

        const clearField = function (id: string) {
            let theSection = 1
            let field2: { [s: string]: any } = {}
            schemaSections.forEach(function (si, sindex) {
                let found
                if (si.instances && si.instances[setIndex] && si.instances.length > 0) {
                    found = si.instances[setIndex].fields.find(function (fi: { id: string }) {
                        return fi.id === id
                    })
                }
                if (found) {
                    theSection = sindex
                    field2 = found
                }
            })
            field2.disp = false
            let clearThis = false
            if (field2.type == 'checkboxGroup') {
                field2.value.map(function (item: { key: any }, i: any) {
                    let checkBoxField: { [s: string]: any } = {}
                    fieldset.fields.map(function (CheckField: { [s: string]: any }, Id: any) {
                        CheckField.id == item.key ? (checkBoxField = CheckField) : null
                    })
                    let ctx = {
                        sectionId: theSection + '',
                    }

                    checkBoxField.fieldIndex = []
                    checkBoxField.value = null
                    formHelp.postValues(
                        null,
                        ctx,
                        checkBoxField,
                        schemaSections,
                        templateType,
                        addAuditComment,
                        setPopUpInfo,
                        setShowPopupMessage
                    )
                })
            } else if (
                (field2.value != null || field2.fieldValue != null) &&
                (field2.value >= 0 ||
                    (field2.fieldValue && field2.fieldValue.length > 0) ||
                    (field2.fieldIndex && field2.fieldIndex.length > 0))
            ) {
                if (field2.value >= 0 || typeof field2.value == 'string') clearThis = true
                //  else if (field2.type == "radio") clearThis = true;
                else if (field2.fieldIndex.length === 0 && field2.fieldIndex[0] === -1)
                    clearThis = true
            }
            if (clearThis) {
                field2.value = null
                let ctx = {
                    sectionId: theSection + '',
                }
                field2.fieldNewValue = [-1]
                field2.fieldIndex = []
                formHelp.postValues(
                    null,
                    ctx,
                    field2,
                    schemaSections,
                    templateType,
                    addAuditComment,
                    setPopUpInfo,
                    setShowPopupMessage
                )
            }
        }

        let parentField = {
            id: 'n/a',
            name: 'n/a',
        } as { [s: string]: any }
        const tempArray = v.parent.toString()
        const parentArray = tempArray.split(',').map(function (st3: string) {
            return st3.trim()
        })
        let dependencyResult = true
        parentArray.forEach(function (p: string) {
            if (p) {
                if (!field.disp) return false // break foreach if fied is hidden by its first parent.
                parentField = getParentField(schemaSections, p)

                if (!parentField) {
                    return true
                }

                tab = tab + '...'
                if (
                    !formHelp.isDependencyOk2(
                        loaded,
                        parentField,
                        setIndex,
                        schemaSections,
                        validatorMetaMap,
                        templateType,
                        fieldset,
                        tab,
                        addAuditComment,
                        setPopUpInfo,
                        setShowPopupMessage
                    )
                ) {
                    if (!(parentField.id == '381')) clearField(field.id)
                    return false
                }
            }

            const condition = v.condx.toUpperCase()
            const conditions = condition.split(',').map(function (st3: string) {
                return st3.trim()
            })
            const getLabel = function (cf: { [s: string]: any }) {
                let cv
                if (formHelp.hasFieldIndex(cf)) {
                    cv = cf.fieldIndex[0]
                    let offset = cf.type === 'select' ? 0 : -1
                    return cv && cv >= 1 ? parentField.domain[cv + offset].value : ''
                }
                if (!cf.value) return parentField.domain[cf.fieldValue[0] - 1].value
                cv = cf.value
                if (!cv || cv === -1) return ''
                return parentField.domain[cf.FieldValue[0]].value
            }
            let result = true

            if (
                parentField.type === 'checkbox' ||
                parentField.type === 'radio' ||
                parentField.type === 'sectionChild'
            ) {
                const yesOrNo = formHelp.isYesNoField(parentField, 0)
                if (yesOrNo >= -1) {
                    parentValue = yesOrNo === 1 ? 'YES' : 'NO'
                } else {
                    try {
                        //parentValue = getLabel(parentField).toUpperCase();
                        parentValue =
                            parentField.fieldValue[0] != null
                                ? parentField.fieldValue[0].toUpperCase()
                                : null
                    } catch (ex) {
                        console.error('*EXCP* ' + ex + ' with ' + JSON.stringify(parentField))
                    }
                }

                if (!conditions.includes(parentValue)) {
                    result = false
                }
            } else if (parentField.type === 'select') {
                parentValue = getLabel(parentField).toUpperCase()
                if (!conditions.includes(parentValue)) {
                    result = false
                }
            } else {
                if (field.id === '5005') {
                    if (field.value) {
                        clearField('5008')
                    }
                }
                if (conditions[0] === '') {
                    if (parentField.value) result = false
                } else if (parentField.id === '5005') {
                    if (field.id === '5008') {
                        if (field.value === 1) {
                            parentField.value =
                                parentField.value != null ? parentField.value.split(' ')[0] : ''
                            //    clearField(parentField.id);
                        }
                    } else if (field.id === '5007') {
                        if ((parentField.value || '').length === 0) result = false
                    }
                } else if (conditions[0] === 'DATE') {
                    if ((parentField.value || '').length === 0) result = false
                    // if (dateTimePairs[parentField.id]) result = false; // Combined DT fields
                } else {
                    try {
                        let pNum = Number(parentField.value)
                        let pRange = condition.split('-').map(function (n: any) {
                            return Number(n)
                        })
                        if (pRange.length === 1 && pNum !== pRange[0]) result = false
                        else if (pRange.length === 2 && (pNum < pRange[0] || pNum > pRange[1]))
                            result = false
                    } catch (e) {
                        result = false
                    }
                }
            }

            field.disp = true

            if (!result && loaded) {
                field.disp = false
                if (
                    parentField.id !== '381' + '' ||
                    parentField.id !== '38301' + '' ||
                    parentField.id !== '38302' + ''
                )
                    clearField(field.id)
            }

            dependencyResult = result
        })
        return dependencyResult
    },
    isYesNoField: function (field: { [s: string]: any }, index: number) {
        if (typeof field.domain == 'string' && typeof field.domain != 'object')
            // Modify this later to check on radio/checkbox/dropdown
            field.domain = JSON.parse(field.domain)

        let parsedValue: any = field.value
        if (field.type.toLowerCase() == 'checkboxgroup' && typeof field.value != 'object') {
            parsedValue = JSON.parse(field.value)
        }
        if (field.domain != null && field.domain.length === 2) {
            // if (!field.value) return false;
            if (field.isYesNo === undefined) {
                field.isYesNo = false
                const d1 = field.domain[0].key.toLowerCase()
                const d2 = field.domain[1].key.toLowerCase()
                if (d1 === 'no' && d2 === 'yes') field.isYesNo = true
                if (d1 === 'yes' && d2 === 'no') field.isYesNo = true
            }
            if (!field.isYesNo) return -2
            if (formHelp.hasFieldIndex(field)) {
                const mix = field.fieldIndex.length - 1
                if (mix < 0 || index > mix) return -1
                const fv = field.fieldIndex[index]
                if (fv === 1) return 0
                if (fv === 2) return 1
                return -1
            }
            if (parsedValue === 1 || parsedValue === 'YES' || parsedValue === 'yes') return 1
            if (parsedValue === 0 || parsedValue === 'NO' || parsedValue === 'no') return 0
            return -1
        }
        return -2
    },
    enableCondition: function (id: any, validatorMetaMap: ValidatorMetaMap, templateType: string) {
        //debugger;
        const validatorMeta = validatorMetaMap[templateType]
        let validator = validatorMeta.filter(function (obj: { id: any }) {
            return obj.id === id
        })[0]

        if (validator === undefined || validator === null) {
            var id2 = id
            // console.error('Validator undefined for id: ' + id + ' defaulting to text.')
            validator = {
                id: id2,
                name: 'unknown',
                vrx: /.*/,
                width: 1000,
                help: 'Use regular text.',
                condx: '',
            }
        }

        if (validator?.parent !== undefined) {
            let r = {
                parent: validator.parent,
                condx: validator.condx,
            }

            return r
        }

        return null
    },
    postValues: function (
        val: number | null,
        context: { sectionId: string },
        field: { [s: string]: any },
        schemaSections: { [s: string]: any },
        templateType: string,
        addAuditComment: (s: string) => void,
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void,
        setShowPopupMessage: (show: boolean) => void
    ) {
        let formLockGuid = ''
        if (sessionStorage.getItem('formLockGuid') != undefined)
            formLockGuid = sessionStorage.getItem('formLockGuid') || ''

        let hindex = document.location.href.indexOf('#section'),
            endpointUrl =
                getBaseUrl() +
                'API/v3/FORMENGINE?type=' +
                templateType +
                '&formtype=' +
                templateType +
                '&lockGuid=' +
                formLockGuid,
            xhr = new XMLHttpRequest(),
            formQuery = document.location.href
                .substring(document.location.href.indexOf('?') + 1)
                .split(':')
        const skipDictionary: { [s: string]: string } = {
            2: '2',
            10: '10',
            14: '14',
            16: '16',
        }
        if (skipDictionary[context.sectionId] != undefined) return

        let sectionId = schemaSections[context.sectionId].dataObjectId
        if (sectionId === null) {
            schemaSections.forEach(function (sx: { instances: { fields: any }[] }, idx: number) {
                const foundS = sx.instances[0].fields.find(function (fld: any) {
                    return fld === field.id
                })
                if (foundS) sectionId = idx + 1
            })
        }
        const PostObj = {
            sectionId: sectionId
                ? sectionId
                : parseInt(document.location.href.substring(hindex + 8), 10),
            dataObjectId: getUrlVars()['dataObjectId'],
            fieldId: field.id,
            fieldType: field.type,
            fieldName: field.name,
            position: field.position,
            fieldNewValue: val + '',
            postByIndex: false,
        }

        if ((field.fieldIndex && field.fieldIndex.length > 0) || field.forceFieldIndex) {
            PostObj.fieldNewValue = field.fieldIndex
            PostObj.postByIndex = true
        } else {
            PostObj.postByIndex = false
            PostObj.fieldNewValue = (function (v) {
                if (v && v.constructor === Array) {
                    return v
                } else if (field.type.toLowerCase() == 'checkboxgroup') {
                    return [v, field.checked]
                } else if (field.type.toLowerCase() == 'radio' && field.fieldIndex != null)
                    return field.fieldValue
                else return [v]
            })(val)
        }

        let audtitFieldMessage = ''
        if (field.audit && PostObj.fieldNewValue != null) {
            let oldVal = field.fieldValue[0] != null ? field.fieldValue[0] : 'Unknown'
            let newVal = val != null ? val : 0

            if (field.type.toLowerCase() == 'radio' && field.domain.length > 0 && newVal > -1) {
                newVal = field.domain[newVal - 1].value
            }
            if (field.fieldValue != undefined) {
                if (PostObj.fieldNewValue[0] != field.fieldValue[0]) {
                    audtitFieldMessage = field.name + ' changed from ' + oldVal + ' to ' + newVal
                    addAuditComment('* ' + audtitFieldMessage)
                }
            } else {
                if (PostObj.fieldNewValue[0] != null) {
                    audtitFieldMessage = field.name + ' changed from ' + oldVal + ' to ' + newVal
                    addAuditComment('* ' + audtitFieldMessage)
                }
            }
        }
        let obj = [PostObj]
        let js = JSON.stringify(obj)

        xhr.open('POST', endpointUrl)
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.setRequestHeader('postByIndex', PostObj.postByIndex?.toString())
        xhr.onreadystatechange = function () {
            let sentObj = js
            if (xhr.readyState === 4) {
                let st = JSON.parse(xhr.response)
                field.savedstatus = st
                if (st.statusMessage !== 'Success') {
                    field.savedstatus = 400
                    console.error(
                        '*ERR* STORE FAILED Field: ' + JSON.stringify(sentObj),
                        ' Server said: ' + st.statusMessage
                    )
                    setPopUpInfo(
                        'Attention',
                        'Form is locked by other user while you were waiting. Please try again in sometime.',
                        true,
                        -1,
                        []
                    )
                    setShowPopupMessage(true)
                    window.setTimeout(function () {
                        location.reload()
                    }, 4000)
                } else {
                    let lockedData = {} as any
                    lockedData = st.data
                    if (formLockGuid == lockedData.LockGuid) {
                        sessionStorage.setItem('formLockGuid', lockedData.LockGuid)
                    }
                }
            }
        }
    },
    vSegFieldCount: (sections: any[]) => {
        let vCount = 0
        sections.forEach((section) => {
            const fields = section.instances[0].fields
            fields.forEach((field: { type: string }) => {
                if (field.type == 'single-select-dropdown' || field.type == 'multi-select-dropdown')
                    vCount++
            })
        })
        return vCount
    },
    generateGuid: function () {
        var d = new Date().getTime()
        var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
        })
        return guid
    },
    stripHtml: function (html: string) {
        let tmp = document.createElement('DIV')
        tmp.innerHTML = html
        const text = tmp.textContent || tmp.innerText || ''
        tmp.remove()
        return text
    },
}
